import React from 'react';
import {inject, observer} from 'mobx-react';

import E9TopLogo from '../E9TopLogo';
import E9QuickSearch from '../E9QuickSearch';
import E9Home from './E9Home';
import E9HeaderRight from '../E9HeaderRight';

@inject('portalThemeStore')
@observer
class E9Header extends React.Component {
    render() {
        return (
            <div className="e9header-container" style={{color: '#fff'}}>
                <div style={{float: 'left', width: '60%'}}>
                    <div style={{float: 'left'}}>
                        <E9TopLogo {...this.props} />
                    </div>
                    <div style={{float: 'right'}}>
                        <E9Home {...this.props} />
                        <E9QuickSearch {...this.props} />
                    </div>
                    <div style={{clear: 'both'}}></div>
                </div>
                <div style={{float: 'right', width: '40%'}}>
                    <E9HeaderRight {...this.props} />
                </div>
            </div>
        );
    }
}

export default E9Header;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/layout5/E9Header.js